import { render } from "./about-num-component.vue?vue&type=template&id=340080e8&scoped=true"
import script from "./about-num-component.vue?vue&type=script&lang=js"
export * from "./about-num-component.vue?vue&type=script&lang=js"

import "./about-num-component.vue?vue&type=style&index=0&id=340080e8&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340080e8"]])

export default __exports__